/**
 * Avatar Group — frontend view module.
 *
 * Wires the +N overflow tile: clicking it reveals the hidden avatars inline
 * (CSS shows `.is-hidden` items once the root gains `.is-expanded`) and hides
 * the tile. Name tooltips are pure CSS (see style.scss), so no JS is needed
 * for them. Nothing runs on pages without the block.
 *
 * @package BrandyBlocks
 */

const SELECTOR = '[data-brandy-avatargroup][data-expandable="1"]';

function bootstrap() {
  document.querySelectorAll(SELECTOR).forEach((root) => {
    const btn = root.querySelector('.brandy-avatar-overflow__btn');
    if (!btn) return;

    btn.addEventListener('click', () => {
      root.classList.add('is-expanded');
      btn.setAttribute('aria-expanded', 'true');
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
} else {
  bootstrap();
}
